<template>
  <li class="reply-templates-template-list-item" v-if="template">
    <div class="reply-templates-template-list-item__template-text">
      {{ template.text }}
    </div>
    <div class="reply-templates-template-list-item__actions">
      <v-btn icon color="primary" @click="editTemplate" class="mr-2">
        <v-icon>
          icon-edit
        </v-icon>
      </v-btn>
      <v-btn icon color="pink" @click="deleteTemplate" class="mr-2">
        <v-icon>
          icon-trash
        </v-icon>
      </v-btn>
    </div>
  </li>
</template>

<script>
export default {
  name: "ReplyTemplatesTemplateListItem",
  props: {
    template: {
      type: Object,
      required: true
    }
  },
  methods: {
    editTemplate() {
      this.$emit("edit", this.template);
    },
    deleteTemplate() {
      this.$emit("delete", this.template);
    }
  }
};
</script>

<style lang="scss" scoped>
.reply-templates-template-list-item {
  display: flex;
  padding: $spacing * 1.75 0;
  justify-content: space-between;
  font-weight: 500;
  color: $text;

  &:not(:last-child) {
    border-bottom: 1px solid $light-3;
  }

  &__template-text,
  &__actions {
    display: flex;
    align-items: center;
    padding-right: $spacing;
  }

  &__template-text {
    width: 75%;
    white-space: pre-line;
  }

  &__actions {
    width: 20%;
  }

  &__actions {
    justify-content: flex-end;
  }
}
</style>
